import type { ReactNode } from 'react'

export function ShellHeader({ selector }: { selector?: ReactNode }) {
  if (!selector) return null

  return (
    <div
      data-shell-context-header
      className="border-b border-[var(--sidebar-divider)] px-3 py-2.5"
    >
      {selector}
    </div>
  )
}
